"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccentColor = exports.BackgroundColor = exports.SemanticColor = exports.NeutralColor = exports.SecondaryColor = exports.PrimaryColor = void 0;
var PrimaryColor;
(function (PrimaryColor) {
    PrimaryColor["PRIMARY_50"] = "#E4F2FF";
    PrimaryColor["PRIMARY_100"] = "#BDDEFF";
    PrimaryColor["PRIMARY_200"] = "#93CBFF";
    PrimaryColor["PRIMARY_300"] = "#69B6FF";
    PrimaryColor["PRIMARY_400"] = "#4BA6FF";
    PrimaryColor["PRIMARY_500"] = "#3496FE";
    PrimaryColor["PRIMARY_600"] = "#3488EF";
    PrimaryColor["PRIMARY_700"] = "#3176DB";
    PrimaryColor["PRIMARY_800"] = "#2E64C9";
    PrimaryColor["PRIMARY_900"] = "#2945A9";
})(PrimaryColor || (exports.PrimaryColor = PrimaryColor = {}));
//Used alongside the primary to indicate to the user it’s the secondary focus.
var SecondaryColor;
(function (SecondaryColor) {
    SecondaryColor["SECONDARY_50"] = "#DBF1FF";
    SecondaryColor["SECONDARY_100"] = "#BAD9E7";
    SecondaryColor["SECONDARY_200"] = "#9ABDCF";
    SecondaryColor["SECONDARY_300"] = "#77A1B6";
    SecondaryColor["SECONDARY_400"] = "#5D8CA3";
    SecondaryColor["SECONDARY_500"] = "#427891";
    SecondaryColor["SECONDARY_600"] = "#366A80";
    SecondaryColor["SECONDARY_700"] = "#27566A";
    SecondaryColor["SECONDARY_800"] = "#1A4355";
    SecondaryColor["SECONDARY_900"] = "#062E3E";
})(SecondaryColor || (exports.SecondaryColor = SecondaryColor = {}));
//Used to support primary and secondary colors in text colors, separators, etc.
var NeutralColor;
(function (NeutralColor) {
    NeutralColor["NEUTRAL_GREY_50"] = "#E4E4E4";
    NeutralColor["NEUTRAL_GREY_100"] = "#C9C9C9";
    NeutralColor["NEUTRAL_GREY_200"] = "#AFAFAF";
    NeutralColor["NEUTRAL_GREY_300"] = "#969696";
    NeutralColor["NEUTRAL_GREY_400"] = "#7D7D7D";
    NeutralColor["NEUTRAL_GREY_500"] = "#666666";
    NeutralColor["NEUTRAL_GREY_600"] = "#4F4F4F";
    NeutralColor["NEUTRAL_GREY_700"] = "#393939";
    NeutralColor["NEUTRAL_GREY_800"] = "#252525";
    NeutralColor["NEUTRAL_GREY_900"] = "#121212";
    NeutralColor["NEUTRAL_DARK"] = "#232323";
})(NeutralColor || (exports.NeutralColor = NeutralColor = {}));
var SemanticColor;
(function (SemanticColor) {
    SemanticColor["ERROR_100"] = "#f8c6c8";
    SemanticColor["ERROR_MEDIUM"] = "#CE3450";
    SemanticColor["ERROR"] = "#E7424D";
    SemanticColor["ERROR_300"] = "#7f1c2e";
    SemanticColor["WARNING_100"] = "#FFF1A9";
    SemanticColor["WARNING"] = "#FFE135";
    SemanticColor["WARNING_300"] = "#A18A05";
    SemanticColor["INFO_MEDIUM"] = "#1876FA";
    SemanticColor["SUCCESS_100"] = "#ACF5DA";
    SemanticColor["SUCCESS"] = "#10E9B6";
    SemanticColor["SUCCESS_300"] = "#088264";
})(SemanticColor || (exports.SemanticColor = SemanticColor = {}));
var BackgroundColor;
(function (BackgroundColor) {
    BackgroundColor["WHITE"] = "#FFFFFF";
    BackgroundColor["LIGHT_GREY"] = "#F1F1F1";
    BackgroundColor["LIGHT_BLUE"] = "#F6F8FC";
})(BackgroundColor || (exports.BackgroundColor = BackgroundColor = {}));
var AccentColor;
(function (AccentColor) {
    AccentColor["RED"] = "#CE3450";
    AccentColor["ORANGE_100"] = "#FFDDC8";
    AccentColor["ORANGE"] = "#F3893E";
    AccentColor["ORANGE_300"] = "#975323";
    AccentColor["GREEN_100"] = "#DEF7F3";
    AccentColor["GREEN"] = "#2BD4C6";
    AccentColor["GREEN_300"] = "#16837A";
})(AccentColor || (exports.AccentColor = AccentColor = {}));
